import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'gray';
  className?: string;
  label?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'primary',
  className = '',
  label = 'Loading...'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8'
  };

  const colorClasses = {
    primary: 'border-f1-red',
    white: 'border-white',
    gray: 'border-f1-gray-400'
  };

  const spinnerClasses = `
    animate-spin 
    rounded-full 
    border-2 
    border-t-transparent
    ${sizeClasses[size]}
    ${colorClasses[color]}
    ${className}
  `;

  return (
    <div className="flex items-center justify-center" role="status" aria-label={label}>
      <div className={spinnerClasses} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
};

export default LoadingSpinner;